(() => {
  if (window.SakuraPdpAccordionRepair) return;

  const resizeControlledRegion = (trigger) => {
    const controlledId = trigger.getAttribute('aria-controls');
    if (!controlledId) return;
    const content = document.getElementById(controlledId);
    if (!content || !content.classList.contains('js-accordion-content')) return;
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    content.style.maxHeight = isExpanded ? `${content.scrollHeight}px` : '0px';
  };

  const repairExpandedRegions = (root = document) => {
    root.querySelectorAll('.template-product .js-accordion-trigger[aria-controls][aria-expanded="true"]').forEach(resizeControlledRegion);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.template-product .js-accordion-trigger[aria-controls]');
    if (!trigger) return;
    window.requestAnimationFrame(() => resizeControlledRegion(trigger));
  });

  window.addEventListener('resize', () => repairExpandedRegions());
  document.addEventListener('shopify:section:load', (event) => repairExpandedRegions(event.target));
  window.SakuraPdpAccordionRepair = { repairExpandedRegions, resizeControlledRegion };
})();
